import { render, staticRenderFns } from "./ModalAtencion.vue?vue&type=template&id=1d54f2fa"
import script from "./ModalAtencion.vue?vue&type=script&lang=ts"
export * from "./ModalAtencion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports